import { render, staticRenderFns } from "./GlossaryRegionsNew.vue?vue&type=template&id=6039499b&"
import script from "./GlossaryRegionsNew.vue?vue&type=script&lang=js&"
export * from "./GlossaryRegionsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports